import React from 'react'

import useThemeSettings from 'customizer/theme/useThemeSettings'
import CommonTextQuestion from 'themes/common/components/questions/TextQuestion'

import './TextQuestion.scss'

const TextQuestion = props => {
  const style = useThemeSettings('textInputAndDropdown')

  return <CommonTextQuestion {...props} minRows={2} maxRows={2} textInputAndDropdownStyle={style} />
}

export default TextQuestion
